module.exports = "bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvYXNzZXRzL2ViNjRlNzA2ZWI3YTNiMzI0YmE1MGQzMjc5YTk4MGIxLnR0ZiI7"